import { Injectable } from "@angular/core";
import { HttpClient, HttpRequest } from "@angular/common/http";
import { IRefund, IRefundForm, IRefundKilometerForm } from "../models/refunds";

@Injectable({
  providedIn: "root",
})
export class RefundsService {
  public list: IRefund[] = [];
  private baseurl: string = "/refund";
  public mineRefund: IRefund[];
  public refundKilometersList: any = [];

  constructor(private _httpClient: HttpClient) {}

  async getList() {
    return this._httpClient
      .get(this.baseurl)
      .toPromise()
      .then((response: IRefund[]) => {
        this.list = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  async getMineRefund() {
    return this._httpClient
      .get("/me/refund")
      .toPromise()
      .then((response: IRefund[]) => {
        this.mineRefund = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
      });
  }

  async getRefundKilometers(month: string, year: string) {
    return this._httpClient
      .get(`/refund/bonus?month=${month}&year=${year}`)
      .toPromise()
      .then((response) => {
        this.refundKilometersList = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return null;
      });
  }

  addRefundKilometers(data: IRefundKilometerForm) {
    return this._httpClient.post("/refund/bonus", data).toPromise();
  }

  editRefundKilometers(id: number, data: { bonus_extra: string } | { bonus: string }) {
    return this._httpClient.put("/refund/bonus/" + id, data).toPromise();
  }

  async deleteRefundKilometers(id: number) {
    return this._httpClient.delete("/refund/bonus/" + id).toPromise();
  }

  async delete(id: number) {
    return this._httpClient
      .delete(this.baseurl + "/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }

  async create(data: IRefundForm) {
    return this._httpClient
      .post(this.baseurl, data)
      .toPromise()
      .then(async (response) => {
        await this.getMineRefund();
        return response;
      });
  }

  async update(id: number, data: { has_file: number }) {
    return this._httpClient
      .put(this.baseurl + "/" + id, data)
      .toPromise()
      .then(async () => {
        await this.getList();
      });
  }

  async updateRequestedRefund(actions: string, data: any) {
    return this._httpClient
      .post(this.baseurl + "/" + actions, data)
      .toPromise()
      .then(async () => {
        await this.getList();
      });
  }

  async uploadAttachment(file: any, id: number) {
    const formData: FormData = new FormData();
    formData.append("file", file);
    const req: any = new HttpRequest("PUT", `/refund/upload/${id}`, formData);
    return this._httpClient.request(req).toPromise();
  }
}
